/*
 * XS fine jewelry ship-by line, cart drawer and cart page. 3 Nov 2026.
 *
 * Adds "Ships by ... Standard arrives ..." under every fine jewelry (Stuller)
 * line in the cart drawer and on the cart page, without touching the stock
 * cart-products snippet (which Horizon updates keep reverting):
 *   1. read /cart.js for the lines (vendor, handle, variant, price);
 *   2. for each Stuller line, fetch /products/<handle>?view=xs-eta, a
 *      layout-less template (templates/product.xs-eta.liquid) that prints the
 *      stuller.ship_info metafield as JSON - cached per handle;
 *   3. find the line's row by its product link (?variant=<id>) and append the
 *      text under the variant details.
 * Loaded from layout/theme.liquid, because the drawer is injected through the
 * Section Rendering API where inline scripts never run. A MutationObserver
 * re-applies the lines whenever the drawer or cart page re-renders.
 *
 * Same math as snippets/xs-ship-eta.liquid (product page). Keep HANDLING,
 * TRANSIT, the $500 insured threshold and HOLIDAYS identical in both files.
 */
(function () {
  var HANDLING = 1;
  var TRANSIT = { standard: 3, twoDay: 2 };
  var INSURED_2DAY_CENTS = 50000;
  var HOLIDAYS = [
    '2026-11-26', '2026-11-27', '2026-12-24', '2026-12-25', '2026-12-31',
    '2027-01-01', '2027-05-31', '2027-07-05', '2027-09-06',
    '2027-11-25', '2027-11-26', '2027-12-24', '2027-12-31'
  ];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var infoCache = {};

  function key(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function isWorkday(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) === -1;
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) n--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function shipInfo(handle) {
    if (!infoCache[handle]) {
      infoCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=xs-eta', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : 'null'; })
        .then(function (t) { try { return JSON.parse(t.trim() || 'null'); } catch (e) { return null; } })
        .catch(function () { return null; });
    }
    return infoCache[handle];
  }

  function lineText(lead, priceCents) {
    var ships = addBusinessDays(new Date(), HANDLING + lead);
    var insured = priceCents >= INSURED_2DAY_CENTS;
    var arrive = addBusinessDays(ships, insured ? TRANSIT.twoDay : TRANSIT.standard);
    return (lead <= 1 ? 'In stock. ' : '') + 'Ships by ' + fmt(ships) + '. ' +
      (insured ? 'Free insured 2-Day arrives ' : 'Standard arrives ') + fmt(arrive) + '.';
  }

  function place(variantId, text) {
    var links = document.querySelectorAll('.cart-items a[href*="variant=' + variantId + '"], .cart-items__table-row a[href*="variant=' + variantId + '"]');
    var seen = [];
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest('.cart-items__table-row, tr, li');
      if (!row || seen.indexOf(row) !== -1) continue;
      seen.push(row);
      var existing = row.querySelector('.xs-eta-line');
      if (existing) { if (existing.textContent !== text) existing.textContent = text; continue; }
      var p = document.createElement('p');
      p.className = 'xs-eta-line';
      p.style.cssText = 'margin:4px 0 0;font-size:0.8125rem;line-height:1.35;color:#8a6d3b;font-weight:500;';
      p.textContent = text;
      var host = row.querySelector('.cart-items__variants-wrapper') || row.querySelector('.cart-items__details') || row;
      host.appendChild(p);
    }
  }

  var running = false, again = false;
  function apply() {
    if (!document.querySelector('.cart-items__table-row')) return;
    if (running) { again = true; return; }
    running = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var jobs = (cart.items || []).filter(function (it) { return it.vendor === 'Stuller'; }).map(function (it) {
          return shipInfo(it.handle).then(function (info) {
            if (!info || !info.lead_time_days) return;
            var v = info.variants && info.variants[String(it.variant_id)];
            var lead = parseInt(v != null ? v : info.lead_time_days, 10);
            if (lead > 0) place(it.variant_id, lineText(lead, it.final_price));
          });
        });
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; apply(); }
      });
  }

  function start() {
    apply();
    var timer = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!t || !t.closest || t.closest('.xs-eta-line')) continue;
        // Only cart re-renders matter; ignore the rest of the page's churn.
        if (!t.closest('#cart-drawer, cart-drawer-component, cart-items-component, .cart-items-component, .cart-items, main')) continue;
        if (t.closest('main') && !document.querySelector('main .cart-items__table-row')) continue;
        clearTimeout(timer);
        timer = setTimeout(apply, 250);
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
